import { render, staticRenderFns } from "./CatalogueAdmin.vue?vue&type=template&id=0438fe16&scoped=true&"
import script from "./CatalogueAdmin.vue?vue&type=script&lang=js&"
export * from "./CatalogueAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0438fe16",
  null
  
)

export default component.exports